const waitForSubresources = async (targetDocument) => {
  // Currently only handles images
  let images = Array.from(targetDocument?.querySelectorAll('img') ?? []);

  if (images.length === 0) {
    // No images in document
    return;
  }

  // Filter out lazy-loaded images - they won't load until visible
  const eagerImages = images.filter((img) => img.loading !== 'lazy');

  if (eagerImages.length === 0) {
    return;
  }

  let promises = [];
  eagerImages.forEach((image, index) => {
    promises.push(
      new Promise((resolve) => {
        if (image.complete) {
          resolve();
          return;
        }

        let loadHandler = () => {
          // The subresources have finished loading.
          image.removeEventListener('load', loadHandler);
          image.removeEventListener('error', loadHandler);

          resolve();
        };

        image.addEventListener('load', loadHandler);
        image.addEventListener('error', loadHandler);
      }),
    );
  });

  const timeoutPromise = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 10000);
  });

  // Don't prevent the book content from appearing, but do wait up to 10 seconds for subresources to load.
  await Promise.race([Promise.all(promises), timeoutPromise]);
};

export default waitForSubresources;
